import styled from 'styled-components'

const StyledLessonTabs = styled.div`
  width: 100%;
  display: flex;
  margin-top: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};

  button {
    padding: 14px 0;
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.color.gray[400]};
    background: transparent;
    position: relative;
    display: flex;
    align-items: center;
    transition: 0.2s;

    .count {
      margin-left: 8px;
      font-size: 13px;
      font-weight: 600;
      height: 20px;
      min-width: 20px;
      background-color: ${({ theme }) => theme.color.gray[200]};
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: 50rem;
      padding: 0 4px;
      box-sizing: border-box;
    }

    svg {
      height: 20px;
      stroke-width: 2.3px;
      margin-left: 4px;
    }

    &:hover {
      color: ${({ theme }) => theme.color.gray[600]};
    }

    &:not(:last-child) {
      margin-right: 20px;
    }

    &[data-active='true'] {
      color: ${({ theme }) => theme.color.gray[900]};

      &::after {
        content: '';
        position: absolute;
        height: 2px;
        bottom: -1px;
        width: 100%;
        border-radius: 10px 10px 0 0;
        left: 0;
        right: 0;
        background-color: ${({ theme }) => theme.color.gray[900]};
      }
    }
  }
`

export default StyledLessonTabs
